import type { TranslationLanguageEntity } from './TranslationLanguageEntity'

export class TranslationEntity {
  id?: number
  key?: string | null
  translationLanguages?: Array<TranslationLanguageEntity> | null
}
